export enum TextVariants {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WHITE = 'white',
}

export enum FontWeight {
  LIGHT = 'light',
  NORMAL = 'normal',
  MEDIUM = 'medium',
  SEMIBOLD = 'semibold',
  BOLD = 'bold',
}
